import _get from 'lodash/get.js';
import { getToolIds, getToolLabel, UNKNOWN_TOOL_LABEL } from './tool.js';
import {
  VISIBILITY_OPTIONS,
  GRADEBOOK_GRADING_TYPES_CHAR_LIMIT,
  GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT,
  IS_DRAFT
} from './constants.js';

function activityLabel (
  type,
  subtype,
  gradingType,
  avoidGradingType,
  activityLabel = ''
) {
  let label = '';
  const subtypeLabel = subtype ? getToolLabel(type, subtype) : null;
  if (activityLabel) {
    label = activityLabel;
  } else if (subtypeLabel && subtypeLabel !== UNKNOWN_TOOL_LABEL) {
    label = subtypeLabel;
  } else {
    label = getToolLabel(type);
  }

  if (
    !avoidGradingType &&
    gradingType === GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT
  ) {
    const isLabelShort = label.length < GRADEBOOK_GRADING_TYPES_CHAR_LIMIT;
    const extraCreditLabel = isLabelShort
      ? `${label} | Extra Credit`
      : 'Extra Credit';
    return isLabelShort ? extraCreditLabel : { label, extraCreditLabel };
  }

  return label;
}

function assignmentActivityLabel (activity, avoidGradingType = false) {
  const name = activity.type || activity.tool;
  const subtype = activity.subtype || _get(activity, 'meta[0].subtype', null);
  const gradingType = activity.grading_type;
  // CW sends us labels in camelCase but coupled db in snake_case
  const activityLabelDesc = activity.labelDesc || activity.label_desc;
  const labelName = activityLabel(
    name,
    subtype,
    gradingType,
    avoidGradingType,
    activityLabelDesc
  );
  return labelName;
}

function getActivityVisibilityStatus (activity) {
  const available = _get(activity, 'visibility_available_date', null);
  const until = _get(activity, 'visibility_until_date', null);
  const visibility = _get(activity, 'visibility');

  if (visibility === 'daysBefore' && available && until) { return VISIBILITY_OPTIONS.DAYS_BEFORE; }
  if ((available && !until) || visibility === VISIBILITY_OPTIONS.ALL) { return VISIBILITY_OPTIONS.ALL; }
  if ((!available && until) || visibility === VISIBILITY_OPTIONS.NONE) { return VISIBILITY_OPTIONS.NONE; }
  if (available && until) return VISIBILITY_OPTIONS.CUSTOM;

  return null;
}

function getDraftOrPeerReviewLabel (name = '', tool, subtype) {
  const draftLabel = getToolLabel(tool, 'draft', 'subtypeLabel');
  const draftPortionList = name.split(':');
  const draftPortion = draftPortionList.pop() || name;
  const label = subtype
    ? getToolLabel(tool, subtype, 'subtypeLabel')
    : draftLabel;
  const sequenceFromName = draftPortion.replace(/^\D+/g, '');

  return IS_DRAFT[label.toLowerCase()]
    ? `${draftLabel} ${sequenceFromName}`
    : `${draftLabel} ${sequenceFromName} ${label}`;
}

function isWritingFinalPaper (tool, parentId) {
  return tool === getToolIds().writing && !parentId;
}

export {
  isWritingFinalPaper,
  getDraftOrPeerReviewLabel,
  getActivityVisibilityStatus,
  assignmentActivityLabel
}
